// extracted by mini-css-extract-plugin
export default {"active":"Ln8ZP"};